<template>
    <div>
        <!--<button @click="open = true"
                class="flex-no-shrink pb-2 text-center flex flex-col justify-between mr-4 mb-4 bg-white cursor-pointer text-center w-4 lg:w-24 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark focus:outline-none text-grey-dark">
            <img class="w-full" src="/images/svg/ATS3bdSeriesicon_analyse.svg">
            <div class="text-sm hidden lg:inline">analyse time series</div>
        </button>-->

        <image-button
                @click.native="open = true"
                img="/images/svg/ATS3bdSeriesicon_analyse.svg"
        >
            analyse time series
        </image-button>

        <portal to="modals" v-if="open">
            <modal v-show="open" @close="close()">
                <h3 slot="header">Analyse</h3>

                <div>

                    <p class="text-grey-dark pb-4">Find longer data histories or more recent data. This tool compares a
                        time-series against million others and finds the best matching ones.</p>

                    <stepper :step="1">
                        <step :id="1">
                            <div slot="default" slot-scope="{ setStep }">
                                <p class="py-2">Select a Time Series to analyze</p>

                                <div>

                                    <ul class="list-reset border-t border-r border-l">
                                        <li
                                                v-for="item in items"
                                                :key="item.identifier"
                                                class="border-b"
                                        >
                                            <a @click="select(item);setStep(2)" class="cursor-pointer hover:bg-blue-lighter">
                                                <div class="flex text-sm p-4">
                                                    <div class="w-3/5 p-2">
                                                        {{ item.name }}

                                                        <div class="pt-2 text-grey">
                                                            Unit: {{ item.unit }}
                                                        </div>
                                                    </div>

                                                    <div class="w-2/5 flex">
                                                        <div class="w-3/5 p-2 flex">

                                                            <div class="w-1/2">
                                                                <span class="text-xs text-grey uppercase tracking-wide">Begin</span><br/>
                                                                {{ item.range.from | limit }}<br>
                                                            </div>

                                                            <div class="w-1/2">

                                                                <span class="text-xs text-grey uppercase tracking-wide">End</span><br/>
                                                                {{ item.range.to | limit }}
                                                            </div>

                                                        </div>

                                                        <div class="w-2/5 p-2">

                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                            </div>

                            <div slot="inactive">
                                <div v-if="item" class="cursor-pointer border hover:bg-blue-lighter">

                                    <div class="flex text-sm p-4">
                                        <div class="w-3/5 p-2">
                                            {{ item.name }}

                                            <div class="pt-2 text-grey">
                                                Unit: {{ item.unit }}
                                            </div>
                                        </div>

                                        <div class="w-2/5 flex">
                                            <div class="w-3/5 p-2 flex">

                                                <div class="w-1/2">
                                                    <span class="text-xs text-grey uppercase tracking-wide">Begin</span><br/>
                                                    {{ item.range.from | limit }}<br>
                                                </div>

                                                <div class="w-1/2">

                                                    <span class="text-xs text-grey uppercase tracking-wide">End</span><br/>
                                                    {{ item.range.to | limit }}
                                                </div>

                                            </div>

                                            <div class="w-2/5 p-2">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </step>

                        <step :id="2">
                            <div slot="default" slot-scope="{ setStep }">
                                <div class="py-4">Select a Time Series to compare.</div>

                                <div>
                                    <loading v-if="loading">computing results</loading>

                                    <div v-if="!loading && resultCount > 0">

                                        <ol class="list-reset border-t border-r border-l">
                                            <li
                                                    v-for="item in result.items"
                                                    @click="selectForCompare(item);setStep(3)"
                                                    class=" cursor-pointer border-b hover:bg-blue-lighter"
                                                    :key="item.identifier"
                                            >
                                                <regression-series :item="item"></regression-series>
                                            </li>
                                        </ol>
                                    </div>

                                    <div v-if="!loading && resultCount === 0">
                                        <p>No matching series found.</p>
                                    </div>

                                </div>

                            </div>
                            <div slot="inactive">
                                <div v-if="compare" class="border cursor-pointer hover:bg-blue-lighter">
                                    <regression-series :item="compare"></regression-series>
                                </div>
                            </div>
                        </step>

                        <step :id="3" :last="true">
                            <slot>
                                <div>
                                    <pattern-chart v-if="compare" :pattern="result.pattern" :data="compare"></pattern-chart>

                                    <button @click="addSeries" class="p-2 bg-blue-dark text-white">Add Series to board
                                    </button>
                                </div>
                            </slot>
                        </step>
                    </stepper>
                </div>
            </modal>
        </portal>
    </div>


</template>

<script>
    import http from '../http';
    import Stepper from "./../../components/Stepper";
    import Step from "./../../components/Step";
    import ImageButton from "./ImageButton";
    import PatternChart from "./../../components/patterns/PatternChart";

    export default {

        components: {
            ImageButton,
            Stepper,
            Step,
            PatternChart
        },

        data: function () {
            return {
                item: null,
                result: {},
                loading: false,
                compare: null,
                open: false,
            };
        },

        computed: {
            items: function () {
                return this.$store.getters.rows;
            },
            pattern: function () {
                if (this.item === null) {
                    return '';
                }

                return this.item.data
                    .filter(function (item) {
                        return item.value !== null;
                    })
                    .map(function (item) {
                        return item.time.substr(0, 4) + ',' + item.value;
                    })
                    .join(';');
            },
            resultCount: function () {
                if (!this.result.items) {
                    return 0;
                }
                return this.result.items.length;
            },
        },

        filters: {
            limit: function (value) {
                return value.substring(0, 4);
            },
        },

        methods: {
            select: function (item) {
                this.item = item;
                this.analyze();
            },
            selectForCompare: function (item) {
                this.compare = item;
                this.step = 3;
            },
            analyze: function () {
                // take the current item and ask for better ones!
                const that = this;
                this.loading = true;
                http.get("/api/unstable/regression/custom:" + this.pattern)
                    .then(function (response) {
                        that.result = response.data;
                        that.loading = false;
                    })
                    .catch(function (response) {
                        that.loading = false;
                    });
            },
            addSeries: function () {
                this.$store.dispatch('addSeries', {id: this.compare.identifier});

                this.close();
            },
            close: function () {
                this.open = false;
            }
        },
    }
</script>
